import { useCallback, useEffect, useState } from "react";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import { useGetTransactionHistoryQuery } from "../../../store/payments/paymentsApi";
import moment from "moment";
import Loading from "../../../shared/Loading";
import Button from "../../../shared/button";
import { IPaymentHistory } from "../../../interfaces/payments/IPaymentsProps";

const PaymentHistory = () => {
  const [invoices, setInvoices] = useState<IPaymentHistory[]>([]);
  const [paginationState, setPaginationState] = useState<IPaginationPayload>({
    pageNumber: 1,
    pageSize: 5,
  });
  const { data, isLoading } = useGetTransactionHistoryQuery(paginationState);

  useEffect(() => {
    if (data) {
      setInvoices([...invoices, ...data.data.elements || []]);
    }
  }, [data]);

  const handleShowMore = useCallback(
    () =>
      setPaginationState({
        ...paginationState,
        pageNumber: paginationState.pageNumber + 1,
        nextPage: data?.data.page?.nextPage,
      }),
    [setPaginationState, paginationState, data]
  );
  return (
    <div className="w-full my-3">
      {isLoading && <Loading />}
      {invoices.map((invoice) => (
        <div className="mb-8 flex flex-wrap">
          <div>
            <div className="font-bold">Invoice: {invoice.transactionId ? '#' +invoice.transactionId : '(no id)'}</div>
            <p className="text-sm text-saloon-details my-1">
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(invoice.amount)}
              {Boolean(invoice.transactionDate) &&
                " * " +
                  moment(invoice.transactionDate).format("DD MMM YYYY HH:mm")}
            </p>
            <p className="text-sm">
              {invoice.status === "succeeded" ? (
                <span className="text-[#008000]">Paid</span>
              ) : (
                <span className="text-[#FF0000]">Not Paid</span>
              )}
            </p>
          </div>
        </div>
      ))}
      {data?.data?.page?.hasNextPage && (
        <Button
          onClickButton={handleShowMore}
          label={"Load More"}
          className="w-full bg-saloon-btn hover:bg-opacity-80 p-3 text-saloon-primary rounded-2xl font-semibold text-base"
          loading={isLoading}
        />
      )}
    </div>
  );
};

export default PaymentHistory;
